import React, { useRef } from 'react';
import { Button, Tag, Text } from '@carnica/ui-kit';
import { LegalBadge } from '@carnica/smart-kit';

import { Banner } from 'pages/MainPage/ui/Banner';
import { ButtonArrow } from 'pages/MainPage/ui/ButtonArrow';
import { MenuUrlTarget } from 'pages/MainPage/utils/utils';
import { Metric } from 'pages/MainPage/metric';

import { BannerCarouselItemProps } from '../types';

export const BannerCarouselItem: React.FC<BannerCarouselItemProps> = ({
  bannerId,
  item,
  sectionTitle,
  bannerPosition,
}) => {
  // для закрытия внтури слайдера во время перелистывания
  const bannerRef = useRef<HTMLAnchorElement>(null);
  return (
    <Metric
      data={JSON.stringify({
        bannerTitle: item.content.title?.text,
        bannerDescription: item.content.subtitle?.text,
        bannerUrl: item.link?.href,
        bannerId,
        bannerPosition,
        blockTitle: sectionTitle,
      })}
      events={{ commonMetric: ['handleInlineBannerView'] }}
      mode="viewport"
      once
      threshold={0.2}
    >
      <Metric
        asChild
        data={JSON.stringify({
          bannerTitle: item.content.title?.text,
          bannerDescription: item.content.subtitle?.text,
          bannerUrl: item.link?.href,
          bannerId,
          bannerPosition,
          blockTitle: sectionTitle,
        })}
        events={{ commonMetric: ['handleInlineBannerClick'] }}
        mode="click"
      >
        <a
          aria-label={item.content.title?.text}
          href={item.link?.href}
          key={item.link?.href}
          ref={bannerRef}
          target={MenuUrlTarget.get(item.link?.isBlankUrlTarget as boolean)}
        >
          <Banner.DesktopBanner
            action={
              item.actions && (
                <Metric
                  asChild
                  data={JSON.stringify({
                    bannerTitle: item.content.title?.text,
                    buttonText: item.actions.label,
                    bannerUrl: item.link?.href,
                    bannerId,
                    bannerDescription: item.content.subtitle?.text,
                    bannerPosition,
                    blockTitle: sectionTitle,
                  })}
                  events={{ commonMetric: ['handleInlineBannerButton'] }}
                  mode="click"
                >
                  <Button
                    href={item.actions.href}
                    size="m"
                    tagName="a"
                    target={MenuUrlTarget.get(item.actions.isBlankUrlTarget as boolean)}
                    view={item.actions.view}
                  >
                    {item.actions.label}
                  </Button>
                </Metric>
              )
            }
            legal={
              item.legal && (
                /* eslint-disable-next-line react/jsx-no-useless-fragment */
                <>
                  {item.legal.type === 'text' ?
                    <Text color={item.legal.color} variant={item.legal.variant}>
                      {item.legal.text}
                    </Text>
                  : <LegalBadge {...item.legal} containerRef={bannerRef} />}
                </>
              )
            }
            style={{
              backgroundImage: `url(${item.img.desktop.url})`,
              backgroundPosition: item.img.desktop?.position,
              backgroundSize: item.img.desktop?.size,
            }}
          >
            {item.content.tag && (
              <Tag size={item.content.tag.size} view={item.content.tag.view}>
                {item.content.tag.label}
              </Tag>
            )}
            {item.content.titleImage && <img alt="" src={item.content.titleImage} />}
            {item.content.title && (
              <Text color={item.content.title.color} variant={item.content.title.variant}>
                {item.content.title.text}
              </Text>
            )}
            {item.content.subtitle && (
              <Text color={item.content.subtitle.color} variant={item.content.subtitle.variant}>
                {item.content.subtitle.text}
              </Text>
            )}
            {item.content.actionButton && (
              <Metric
                asChild
                data={JSON.stringify({
                  bannerTitle: item.content.title?.text,
                  buttonText: item.content.actionButton.label,
                  bannerUrl: item.link?.href,
                  bannerDescription: item.content.subtitle?.text,
                  bannerId,
                  bannerPosition,
                  blockTitle: sectionTitle,
                })}
                events={{ commonMetric: ['handleInlineBannerButton'] }}
                mode="click"
              >
                <Button
                  href={item.content.actionButton.href}
                  size="m"
                  tagName="a"
                  target={MenuUrlTarget.get(item.content.actionButton.isBlankUrlTarget as boolean)}
                  view={item.content.actionButton.view}
                >
                  {item.content.actionButton.label}
                </Button>
              </Metric>
            )}
            {item.content.actionButtonArrow && (
              <Metric
                asChild
                data={JSON.stringify({
                  bannerTitle: item.content.title?.text,
                  buttonText: item.content.actionButtonArrow.label,
                  bannerDescription: item.content.subtitle?.text,
                  bannerUrl: item.link?.href,
                  bannerId,
                  bannerPosition,
                  blockTitle: sectionTitle,
                })}
                events={{ commonMetric: ['handleInlineBannerButton'] }}
                mode="click"
              >
                <ButtonArrow {...item.content.actionButtonArrow}>
                  <Text
                    color={item.content.actionButtonArrow.textColor}
                    variant="body-accent-small"
                  >
                    {item.content.actionButtonArrow.label}
                  </Text>
                </ButtonArrow>
              </Metric>
            )}
          </Banner.DesktopBanner>
        </a>
      </Metric>
    </Metric>
  );
};
